/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
export { DEFAULT_PROPS } from './default-props';

/////////////////////////////////////////////
// COLOR CONFIGURATION
/////////////////////////////////////////////
export const BG_PRIMARY = '#141A14';
export const BG_SECONDARY = '#1F291F';
export const BG_TERTIARY = '#2A362A';
export const BG_ALTERNATIVE = '#1F291F';
export const BG_LAYER = 'rgba(20, 26, 20, 0.72)';

export const TEXT_PRIMARY = '#F4F1EA';
export const TEXT_SECONDARY = '#F4F1EA';
export const TEXT_TERTIARY = '#B8B3A8';
export const TEXT_ALTERNATIVE = '#6E726B';
export const TEXT_BUTTON = '#F4F1EA';

export const ASSET_PATTERN_COLOR = '#C86D51';

export const NAVIGATION_COLOR = {
  base: 'rgba(20, 26, 20, 0.82)',
  icon: TEXT_PRIMARY,
};

export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  className: 'ivt-btn',
  'data-button': 'pill',
  variant: 'unstyled',
  fontFamily: `'Instrument Serif', serif`,
  fontStyle: 'italic',
  fontSize: 'calc(var(--chakra-fontSizes-body) - 2px)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '18px 32px',
  borderRadius: '999px',
  background: 'transparent',
  border: '1px solid',
  borderColor: 'rgba(244, 241, 234, 0.22)',
  color: TEXT_PRIMARY,
  boxShadow: 'none',
  position: 'relative',
  zIndex: '20',
  whiteSpace: 'nowrap',
  transition: 'background-color .2s ease, border-color .2s ease',
  _hover: { background: 'rgba(255,255,255,0.10)', borderColor: TEXT_PRIMARY },
  _active: { background: 'rgba(255,255,255,0.16)' },
  _focusVisible: { outline: '2px solid', outlineColor: TEXT_PRIMARY, outlineOffset: '2px' },
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
